import { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import analyticsAPI from '@/lib/api/analytics';
import { detectBrowserName, detectDeviceType, truncate } from '@/lib/utils/analytics';
import { useAuth } from '@/contexts/AuthContext';

export function PageViewTracker() {
  const location = useLocation();
  const { user } = useAuth();

  const sessionId = useMemo(() => {
    const key = '__analytics_session_id__';
    let sid = sessionStorage.getItem(key);
    if (!sid) {
      sid = `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
      sessionStorage.setItem(key, sid);
    }
    return sid;
  }, []);

  useEffect(() => {
    const sendPageView = async () => {
      try {
        if (!user) return; // Backend verlangt auth
        await analyticsAPI.events.track({
          event_type: 'page_view',
          event_category: 'navigation',
          session_id: sessionId,
          page_url: truncate(window.location.pathname + window.location.search, 500),
          referrer: truncate(document.referrer || undefined, 500),
          user_agent: truncate(navigator.userAgent, 1000),
          device_type: detectDeviceType(navigator.userAgent),
          browser: detectBrowserName(navigator.userAgent),
        });
      } catch (_) {
        // ignore
      }
    };
    void sendPageView();
  }, [location, sessionId, user]);

  return null;
}


